import { useState } from 'react';
import { getFreeStampsSellerProviders } from '../../../../../api/subscription';
import { useOnComponentMount } from '../../../../../../../hooks/use-on-component-mount';
import { LogService } from '../../../../../../../services/log-service';
import { usePaymentAndSubscriptionMegaContext } from '../../../../context';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';

// legacy "types" from billing info
const CREDIT_CARD = 'CreditCard';
const PAYPAL = 'Paypal';

export const useGetStampsPageData = () => {
  const { billingInfo, paymentMethodDetails } = usePaymentAndSubscriptionMegaContext();
  const [sellerStampsProviders, setSellerStampsProviders] = useState([]);
  const [didError, setDidError] = useState(false);

  let paymentMethodName = '';
  switch (billingInfo?.paymentMethod) {
    case CREDIT_CARD: {
      const { creditCard } = billingInfo ?? {};
      const newPaymentMethod = paymentMethodDetails.find((paymentMethod) =>
        paymentMethod.assignedPreferences.includes(TransactionCategory.AddFunds),
      );
      // legacy billingInfo had cardType and lastFour, new payment method has nickname
      paymentMethodName = creditCard ? `${creditCard.cardType} - ${creditCard.lastFour}` : newPaymentMethod?.nickname || '';
      break;
    }
    case PAYPAL:
    default:
    // do nothing
  }

  useOnComponentMount(() => {
    getFreeStampsSellerProviders()
      .then((stampsResp) => {
        setSellerStampsProviders(stampsResp?.data ?? []);
      })
      .catch((error) => {
        LogService.logError(error);
        setDidError(true);
      });
  });

  return {
    paymentMethodType: billingInfo?.paymentMethod,
    paymentMethodName,
    sellerStampsProviders,
    didError,
  };
};
